// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1erS0","list":"BalanceDue_list__iIqNB","listRow":"BalanceDue_listRow__AJDfh","total":"BalanceDue_total__D68Oh"};